export const routes = {
  home: '/',
  capabilities: '/capabilities',
  news: '/news',
  careers: '/careers',
  productsLegacy: '/products',
} as const;

export const homeHash = {
  about: 'about',
  whitepaper: 'whitepaper',
  contact: 'contact',
} as const;

export const capabilityHash = {
  orec: 'orec',
  orecIntelligence: 'orec-intelligence',
  orecSovereign: 'orec-sovereign',
} as const;

export function hashPath(pathname: string, id: string) {
  const hash = id.startsWith('#') ? id.slice(1) : id;
  if (pathname === routes.home) return `/#${hash}`;
  return `${pathname}#${hash}`;
}

export function newsArticlePath(slug: string) {
  return `${routes.news}/${slug}`;
}

export const mainNav = [
  { href: routes.capabilities, text: 'Capabilities' },
  { href: routes.news, text: 'News' },
  { href: routes.careers, text: 'Careers' },
] as const;
